import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from '@Integrations/Runs/queries-core'
import { isRef, ref, Ref } from 'vue'
export function useLastRunsForPipelineByUserQueryV1(pipelineId?: string | Ref<string>, userId?: string | Ref<string>, rebuild?: boolean | Ref<boolean>, ) {
	const _pipelineId = isRef<string>(pipelineId) ? pipelineId : ref<string>(pipelineId)
	const _userId = isRef<string>(userId) ? userId : ref<string>(userId)
	const _rebuild = isRef<boolean>(rebuild) ? rebuild : ref<boolean>(rebuild)
	const result = {
		pipelineId: _pipelineId,
		userId: _userId,
		rebuild: _rebuild,
		...useQuery(() => new q.LastRunsForPipelineByUserQueryV1(_pipelineId.value, _userId.value, _rebuild.value))
	}
	return {
		...result,
		runLastRunsForPipelineByUserQueryV1: result.run,
		modelLastRunsForPipelineByUserQueryV1: result.model,
	}
}

export function useLastRunsQueryV1(organizationUnitId?: string | Ref<string>, rebuild?: boolean | Ref<boolean>, ) {
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>(organizationUnitId)
	const _rebuild = isRef<boolean>(rebuild) ? rebuild : ref<boolean>(rebuild)
	const result = {
		organizationUnitId: _organizationUnitId,
		rebuild: _rebuild,
		...useQuery(() => new q.LastRunsQueryV1(_organizationUnitId.value, _rebuild.value))
	}
	return {
		...result,
		runLastRunsQueryV1: result.run,
		modelLastRunsQueryV1: result.model,
	}
}

export function useRunDetailsQueryV1(organizationUnitId?: string | Ref<string>, runId?: string | Ref<string>, rebuild?: boolean | Ref<boolean>, ) {
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>(organizationUnitId)
	const _runId = isRef<string>(runId) ? runId : ref<string>(runId)
	const _rebuild = isRef<boolean>(rebuild) ? rebuild : ref<boolean>(rebuild)
	const result = {
		organizationUnitId: _organizationUnitId,
		runId: _runId,
		rebuild: _rebuild,
		...useQuery(() => new q.RunDetailsQueryV1(_organizationUnitId.value, _runId.value, _rebuild.value))
	}
	return {
		...result,
		runRunDetailsQueryV1: result.run,
		modelRunDetailsQueryV1: result.model,
	}
}

export function useRunsOfOrganizationQueryV1(organizationUnitId?: string | Ref<string>, ) {
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>(organizationUnitId)
	const result = {
		organizationUnitId: _organizationUnitId,
		...useQuery(() => new q.RunsOfOrganizationQueryV1(_organizationUnitId.value))
	}
	return {
		...result,
		runRunsOfOrganizationQueryV1: result.run,
		modelRunsOfOrganizationQueryV1: result.model,
	}
}

